import { render } from "./SalesTabStatusBooking.vue?vue&type=template&id=ea85e550"
import script from "./SalesTabStatusBooking.vue?vue&type=script&lang=js"
export * from "./SalesTabStatusBooking.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__